import axios from 'axios';

const generateLink = (url: string) => {
  const data = {
    "dynamicLinkInfo": {
      "domainUriPrefix": "https://blankly.finance/links",
      "link": `https://app.blankly.finance/${url}`,
    }
  }
  return axios({
    method: 'post',
    url: "https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=AIzaSyDIGVJmkDdkHER_ShveqRMdMDz9OfKG0Ss",
    data,
  });
}

export {generateLink}
